type SignUpField = InputSignUpForm | PropsCustomPhone

const fieldsV3: SignUpField[] = [
  {
    name: "givenName",
    label: "Nombre",
  },
  {
    name: "familyName",
    label: "Apellido",
  },
  {
    name: "email",
    label: "Email",
    type: "email",
  },
  {
    name: "phone",
    label: "Teléfono",
    preferredCountries: ["cl", "pe", "uy", "mx"],
    localization: "es",
    enableSearch: true,
    searchPlaceholder: "Buscar país",
    searchNotFound: "No se ha encontrado el país buscado",
    dropdownClass: "country-list",
    inputClass: "tel-input",
    containerClass: "react-tel-input",
    inputProps: {
      name: "phone",
      id: "phone",
      autoFocus: false,
    },
    country: "cl",
  },
  {
    name: "password",
    label: "Crear una contraseña",
    type: "password",
  },
]

export default fieldsV3
